import {IOnlineCondolenceSummary} from '../types/resources/OnlineCondolenceSummary';
import {IOnlineCondolenceDetails} from '../types/resources/OnlineCondolenceDetails';
import {IApiService} from './IApiService';
import DateUtils from '../utils/DateUtils';
import { IPost, IPostCreateRequest } from "../types/resources/Post";
import {ICandleLightRequest} from '../types/resources/Candle';

export const mockApiService: IApiService = {
    async getOnlineCondolences(): Promise<IOnlineCondolenceSummary[]> {
        try {
            const response = await fetch('./mockData/mockSummaries.json');
            if (!response.ok) {
                throw new Error(`${response.status}`);
            }

            const data = await response.json();

            return transformObjectDates(data);
        } catch (error) {
            throw error;
        }
    },

    async getOnlineCondolenceByPageUrl(pageUrl: string, securityToken?: string): Promise<IOnlineCondolenceDetails> {
        try {
            const response = await fetch('./mockData/mockDetails.json');
            if (!response.ok) {
                throw new Error(`${response.status}`);
            }

            const data = await response.json();

            return transformObjectDates(data[pageUrl]);
        } catch (error) {
            // Rethrow or handle error appropriately
            throw error;
        }
    },

    async lightOnlineCondolenceCandle(candleData: ICandleLightRequest): Promise<void> {
        console.log('candle lit');
        return Promise.resolve();
    },

    async createPost(postData: IPostCreateRequest): Promise<IPost>{
        const newPost: IPost = {
            id: Date.now(),
            createdOn: new Date(),
            isMarkedAsInappropriate: false,
            isMarkedAsPrivateByAuthor: false,
            ...postData,
        };
        console.log('Mock post created:', newPost);

        const responseData: IPost = {
            id: Date.now(),
            createdOn: new Date(),
            isMarkedAsInappropriate: false,
            isMarkedAsPrivateByAuthor: false,
            ...postData,
        }

        return Promise.resolve(responseData);
    },

    // Reactions
    // async likePost(postId: number): Promise<void> {
    //     console.log(`Mock: Post ${postId} liked`);
    //     return Promise.resolve();
    // },
    // async markPostAsSad(postId: number): Promise<void> {
    //     console.log(`Mock: Post ${postId} marked as sad`);
    //     return Promise.resolve();
    // },
    // async flagPostAsInappropriate(postId: number): Promise<void> {
    //     console.log(`Mock: Post ${postId} flagged as inappropriate`);
    //     return Promise.resolve();
    // },
};

function transformObjectDates(obj: any): any {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    for (let key in obj) {
        if (typeof obj[key] === 'string') {
            // Try transforming the string
            const transformedDate = DateUtils.parseDate(key, obj[key]);
            if (transformedDate) {
                obj[key] = transformedDate;
            }
        } else if (typeof obj[key] === 'object') {
            // Recurse into the object
            transformObjectDates(obj[key]);
        }
    }

    return obj;
}
